import React from "react";
import "./Details.css";
import facebook from "../../../../assets/facebook-2.png";
import twitter from "../../../../assets/twitter-2.png";
import instagram from "../../../../assets/instagram-2.png";

import like from "../../../../assets/like.png";
import dislike from "../../../../assets/dislike.png";
import { Link } from "react-router-dom";

const Details = () => {
	return (
		<div className='details'>
			<div className='content'>
				<div>
					Your online presence is very important to your physical brand. Nowadays,
					hiring personnel scour social media for profiles of candidates for
					screening purposes.
					<br />
					<br />
					Does that mean hiring managers will be looking at your LinkedIn page?
					Almost certainly. But what makes you think they'll stop there? They will
					probably do a full social media check, too. Other social media sites,
					blogs, and websites, plus anything else you do online, leave a trail that
					could lead to negative impressions for potential employers.
					<br />
					<br />
					The truth is, prepping for your interview is just a small part of the
					picture. According to a CareerBuilder survey, 70 percent of employers use
					social media to screen potential candidates during the hiring process. As a
					result of this trend, you should be working to create a personal brand
					through your online presence, not just practicing your responses to
					interview questions. If you haven't started cultivating your presence,
					here's a great checklist to help you get started.
					<br />
					<br />
					<p className='bold'>LinkedIn</p>
					<br />
					Your LinkedIn account isn't likely to have a lot of embarrassing stuff
					floating around, but is it in prime shape? Employers checking social media
					will be sure to start here. Make sure you have a good LinkedIn profile to
					give them a fantastic first impression.
					<br />
					<br />
					Start by asking yourself if everything is up to date. It seems overly
					simple, but it's easy to forget to change your profile after switching jobs
					or positions, getting a new website, or even moving to a new city. Also,
					make smart use of keywords. Sprinkle relevant keywords throughout your
					profile to attract the attention of hiring managers you want to talk to.
					<br />
					<br />
					<p className='bold'>Facebook</p>
					<br />
					Your Facebook page isn't meant to be professional, is it? No, but that
					won't stop potential employers doing a social media check from looking at
					it anyway. Some even go so far as to directly ask for your information and
					to be allowed to fully view your page (no filters), but be wary of any
					company that does that.
					<br />
					<br />
					To ensure potential employers won't see what you don't want them to see, go
					to the top right-hand corner of your profile and click the question mark
					symbol. Then, go to “Privacy Check-Up.” This will allow you to indicate who
					you want to be able to see your future posts, monitor what apps you logged
					into and delete what you don't use anymore, and decide who can see what's
					on your personal profile. Take your time and look over each step carefully.
					<br />
					<br />
					Next, view your activity log, which you can find by clicking the down arrow
					next to the question mark symbol in the right-hand corner of your screen.
					This shows everything you've done on Facebook and whether or not it was
					public. In short, this is what people see when they see you on Facebook.
					What kind of picture does it paint of you?
					<br />
					<br />
					Pay special attention to pictures that show you in a bad light. Illegal
					drugs, constant drinking, or overtly sexual images are major no-nos. In the
					privacy settings, you can set it so any pictures you are tagged in have to
					be reviewed by you before posting on your timeline. If you see pictures
					that you don't really like, remove the tag or ask the people who uploaded
					them to delete.
					<br />
					<br />
					Do you have posts where you rant and rave about politics, relationships, or
					previous employers? They fall into that “seemed like a good idea at the
					time” category, but trust us, they weren't. Look over your posts and weed
					out the things that are most likely to give employers a negative impression
					of you.
					<br />
					<br />
					<p className='bold'>Your personal blog</p>
					<br />
					If you have a professional blog or website, that's fantastic. Demonstrating
					knowledge in your field and the ability to communicate at the same time can
					do wonders for your job prospects. A personal blog, however, might be a
					little more than an online journal. Maybe it talks about your hobbies, your
					experiences dating, or something else from your personal life.
					<br />
					<br />
					Having a personal blog is not a negative if it is done in a moderately
					professional way. Even though you may think nobody reads your blog (and
					maybe you haven't touched it in years), it's still out there and probably
					visible. That means you should revisit your blog and edit if necessary. If
					you don't use it anymore, it may be worth taking down entirely.
					<br />
					<br />
					<p className='bold'>Twitter and Instagram</p>
					<br />
					Odds are you probably have either Twitter or Instagram (or both). That
					means your profiles on these sites are fair game to prospective employers.
					Now, there is the option of having a professional Twitter and Instagram
					profiles — which are open to the public and align with your professional
					brand — and also having private profiles — where you can be more personal.
					However, if having multiple accounts is a bit much for you and you would
					rather just use your personal profiles, then make sure you update your
					privacy settings if you don't want future employers snooping around.
					<br />
					<br />
					For Twitter, go to “Settings” and then “Security and Privacy,” and click
					“Protect My Tweets.” Your tweets will only go to followers now, and anyone
					wishing to follow you must get permission. You can also type your name into
					the search box to check your presence on Twitter. You may find that you've
					been mentioned without your knowledge. Look for any disparaging remarks and
					take care of them — which means you may have to contact the original
					tweeter.
					<br />
					<br />
					For Instagram, go to “Edit Your Profile” and choose “Posts Are Private” to
					hide your profile from peering eyes. Also, make sure to look through your
					tagged photos. If you are tagged in some not-so-pleasant photos by users
					who aren't private, you risk an employer finding it. Luckily, you can
					remove yourself from the post by clicking the three dots in the top right
					corner of the post, selecting “Post Options,” and choosing between “Remove
					Me From Post” or “Hide From My Profile” based on what you think will be
					best.
					<br />
					<br />
					<p className='bold'>Google yourself</p>
					<br />
					Once you've done your social media check and completed a pretty thorough
					clean up of your social media sites, type your name into Google and see
					what comes up. What shows up in this search is, in essence, representative
					of your online brand. Be ready for anything — it could be old comments
					you've left on various news, sports, or pop culture sites, or you may even
					discover that someone else has quoted you or referenced you without your
					knowledge.
					<br />
					Once you've found everything and you are ready to remove them from Google's
					search findings, there are ways to do that by contacting Google itself.
					<br />
					<br />
					<p className='bold'>Finally, Add positive material</p>
					<br />
					Once you've cleaned up all of your online presence, it's impossible to know
					everything that is out there. One more thing you can do that has a dual
					benefit is to start posting on all of your social media sites regularly.
					The key here is to keep your posts positive, fun, and free of any red
					flags. These posts will be some of the most recent hits that a hiring
					manager sees, so they will present you in the light that you want. The
					added benefit is that by adding a lot of new material, you're pushing the
					old material down the list. It doesn't mean that it's not still out there,
					but you can reduce the chances that someone will see it by having a new
					wave of positive material taking the top spots.
					<br />
					<br />
					You may not want to worry about your image on Facebook, Reddit, and
					Twitter, but if you're putting yourself out there and looking for a new
					career, it's a necessary part of today's world. When all is said and done,
					it's still possible to show your personality and have a great time on
					social media without crossing those lines; finding the balance between fun
					and professional isn't as hard as you may think. With these simple tips,
					you can clean up your web trail and start building a better virtual you.
				</div>

				<div className='review-container'>
					<div className='first'>
						Did you enjoy this post?
						<div>
							<img src={like} alt='like' />
							Yes
						</div>
						<div>
							<img src={dislike} alt='dislike' />
							No
						</div>
					</div>

					<div className='second'>
						Share this article on:
						<div>
							<Link to='/'>
								<img src={facebook} alt='facebook' />
							</Link>
							<Link to='/'>
								<img src={twitter} alt='twitter' />
							</Link>
							<Link to='/'>
								<img src={instagram} alt='instagram' />
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Details;
